export interface LandingPageBook {
  imageUrl: string;
  title: string;
  author: string;
  backgroundColor: string;
}

export const landingPageBooks: LandingPageBook[] = [
  {
    imageUrl: '/hunchback-min.jpg',
    title: 'Hunchback',
    author: 'Saou Ichikawa',
    backgroundColor: '#6ED963'
  },
  {
    imageUrl: '/the-names-min.jpg',
    title: 'The Names',
    author: 'Florence Knapp',
    backgroundColor: '#FC9901'
  },
  {
    imageUrl: '/disco-min.jpg',
    title: 'I Make Envy on Your Disco',
    author: 'Eric Schnall',
    backgroundColor: '#DCE0D9'
  },
  {
    imageUrl: '/mothers-min.jpg',
    title: 'All the Mothers',
    author: 'Domenica Ruta',
    backgroundColor: '#519872'
  },
  {
    imageUrl: '/bear-and-the-paving-stone-min.jpg',
    title: 'The Bear and the Paving Stone',
    author: 'Toshiyuki Horie',
    backgroundColor: '#99621E'
  },
  {
    imageUrl: '/glorious-people-min.jpg',
    title: 'Glorious People',
    author: 'Sasha Salzmann',
    backgroundColor: '#4381C1'
  },
  {
    imageUrl: '/leave-it-up-to-you-min.jpg',
    title: 'I Leave It Up to You',
    author: 'Jinwoo Chong',
    backgroundColor: '#8F988C'
  },
  {
    imageUrl: '/disappoint-me-min.jpg',
    title: 'Disappoint Me',
    author: 'Nicola Dinan',
    backgroundColor: '#D3C367'
  },
  {
    imageUrl: '/the-familiar-min.jpg',
    title: 'The Familiar',
    author: 'Leigh Bardugo',
    backgroundColor: '#99621E'
  },
  {
    imageUrl: '/eternal-summer-min.jpg',
    title: 'Eternal Summer',
    author: 'Franziska Gänsler',
    backgroundColor: '#9AC4F8'
  }
]; 